// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/CircularStd-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/CircularStd-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/CircularStd-Book.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/CircularStd-Book.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/CircularStd-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/CircularStd-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/search.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
}

main {
  display: block;
}

h1 {
  font-size: 2em;
  margin: .67em 0;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

pre {
  font-family: monospace,monospace;
  font-size: 1em;
}

a {
  background-color: transparent;
}

abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  text-decoration: underline dotted;
}

b,
strong {
  font-weight: bolder;
}

code,
kbd,
samp {
  font-family: monospace,monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

img {
  border-style: none;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

fieldset {
  padding: .35em .75em .625em;
}

legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

textarea {
  overflow: auto;
}

[type=checkbox],
[type=radio] {
  box-sizing: border-box;
  padding: 0;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

details {
  display: block;
}

summary {
  display: list-item;
}

template {
  display: none;
}

[hidden] {
  display: none;
}

.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  -webkit-user-select: none;
  -ms-touch-action: none;
  touch-action: none;
  -ms-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {
  left: 0;
  right: auto;
}

.noUi-vertical .noUi-origin {
  top: -100%;
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  -webkit-transition: transform .3s;
  transition: transform .3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

.noUi-horizontal {
  height: 18px;
}

.noUi-horizontal .noUi-handle {
  width: 34px;
  height: 28px;
  right: -17px;
  top: -6px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  right: -6px;
  bottom: -17px;
}

.noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {
  left: -17px;
  right: auto;
}

.noUi-target {
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #d3d3d3;
  box-shadow: inset 0 1px 1px #f0f0f0,0 3px 6px -5px #bbb;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #3fb8af;
}

.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  cursor: default;
  box-shadow: inset 0 0 1px #fff,inset 0 1px 7px #ebebeb,0 3px 6px -3px #bbb;
}

.noUi-active {
  box-shadow: inset 0 0 1px #fff,inset 0 1px 7px #ddd,0 3px 6px -3px #bbb;
}

.noUi-handle:before,
.noUi-handle:after {
  content: "";
  display: block;
  position: absolute;
  height: 14px;
  width: 1px;
  background: #e8e7e6;
  left: 14px;
  top: 6px;
}

.noUi-handle:after {
  left: 17px;
}

.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}

.noUi-vertical .noUi-handle:after {
  top: 17px;
}

[disabled] .noUi-connect {
  background: #b8b8b8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

.noUi-pips,
.noUi-pips * {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

.noUi-marker {
  position: absolute;
  background: #ccc;
}

.noUi-marker-sub {
  BACKGROUND: var(--color-grey-bg-btn);
}

.noUi-marker-large {
  BACKGROUND: var(--color-grey-bg-btn);
}

.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  -webkit-transform: translate(-50%, 50%);
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  -webkit-transform: translate(50%, 50%);
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  -webkit-transform: translate(0, 50%);
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.noUi-horizontal .noUi-origin>.noUi-tooltip {
  -webkit-transform: translate(50%, 0);
  transform: translate(50%, 0);
  left: auto;
  bottom: 10px;
}

.noUi-vertical .noUi-origin>.noUi-tooltip {
  -webkit-transform: translate(0, -18px);
  transform: translate(0, -18px);
  top: auto;
  right: 28px;
}

button,
input,
textarea {
  font-family: inherit;
}

html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

ul {
  list-style: none;
  padding: 0;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
ul {
  margin-top: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

ul {
  margin: 0;
}

button {
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

body {
  font-family: "Circular",sans-serif;
  color: var(--color-blacktxt);
}

:root {
  --color-blacktxt: #11253D;
  --color-greytxt: #A4A4A4;
  --color-lightgreytxt: #C4C4C4;
  --color-greybg: #F5F5F5;
  --color-grey-darker-bg: #E8E8E8;
  --color-grey-bg-btn: #AAAAAA;
  --color-promo: #FC6D3E;
  --transition-duration: .3s;
}

.visually-hidden {
  position: absolute !important;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0 !important;
  border: 0 !important;
  height: 1px !important;
  width: 1px !important;
  overflow: hidden;
}

.flex {
  display: flex;
}

.content-wrap {
  flex: 1;
}

.search__btn-open {
  display: none;
}

.noUi-target,
.player__volume .noUi-handle.noUi-handle-lower {
  cursor: pointer;
}

@font-face {
  font-family: "Circular";
  font-style: normal;
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "Circular";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}

@font-face {
  font-family: "Circular";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 50vh;
}

.loading_small {
  min-height: 0;
}

.loading_hidden {
  display: none;
}

@keyframes rotate{
  to { 
    transform: rotate(360deg); 
  }
}

.loading__spinner {
  opacity: 0.7;
  width: 40%;
  animation: rotate 800ms linear infinite; 
}

.profile-loading {
  height: 35px;
}

.profile-loading .loading__spinner {
  width: 30px;
}

.sidebar-loading {
  height: 110px;
}

.sidebar-loading .loading__spinner {
  width: 40px;
}

.tracks-loading .loading__spinner {
  width: 10%;
  min-width: 40px;
}

.modal-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 0;
  background-color: rgba(0, 0, 0, 0.2);
}

.modal-loading .loading__spinner {
  width: 20%;
}

.player-loading .loading__spinner {
  width: 40px;
}

.common-input {
    font-weight: 400;
    height: 30px;
}

.common-input:focus-visible {
  outline: 1px solid #FC6D3E;
}

.common-btn {
  bottom: 20px;
  right: 20px;
  background: #FC6D3E;
  color: #171717;
  font-size: 14px;
  width: 114px;
  height: 32px;
  padding: 10px;
  color: white;
  text-align: center;
  cursor: pointer;
}

.track__btn-dropdown:focus {
  outline: none;
  border-color: var(--color-grey-bg-btn);
}

.track__btn-dropdown:focus circle {
  fill: var(--color-promo);
}

.track__btn-dropdown.btn-dropdown--active
{
  transform: rotate(90deg);
}

.track__btn-dropdown svg {
  transition: transform var(--transition-duration) ease-in-out;
}

.track__name__link::before,
.track__btn-dropdown {
  transition: border-color var(--transition-duration) ease-in-out;
}

.track__name__link {
  transition: color var(--transition-duration) ease-in-out;
}

.track__like-btn svg,
.track__btn-dropdown circle {
  transition: var(--transition-duration) ease-in-out;
  transition-property: fill, color; 
}

.track__like-icon {
  width: 20px;
  height: 18px;
}

.track__name__link:focus {
  color: var(--color-promo);
}

.track__name__link:focus::before {
  border-color: var(--color-promo);
}

.track__like-btn:focus-visible svg {
  color: var(--color-promo);
}

.track__name__link:focus-visible,
.track__like-btn:focus-visible {
  outline: none;
}

.aside__item:last-child {
  margin-bottom: 70px;
}

.aside__search-container {
  display: none;
}

.aside__search {
  max-width: 1010px;
  border: none;
  width: 100%;
  min-width: 250px;
  padding: 15px 12px 15px 47px;
  border-radius: 30px;
  background-color: white;
  color: var(--color-greytxt);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: left 15px center;
  outline: 2px solid transparent;
  transition-property: outline-color,opacity,background-color;
  transition-timing-function: ease-in-out;
  transition-duration: var(--transition-duration);
}

.aside__btn {
  transition-property: background-color;
  transition-timing-function: ease-in-out;
  transition-duration: var(--transition-duration);
}

.aside__btn-note-icon {
  width: 25px;
  height: 27px;
}

.aside__btn-play-icon {
  width: 22px;
  height: 26px;
}

.header__search__field,
.header__user {
  outline: 2px solid transparent;
  transition-property: outline-color,opacity,background-color;
  transition-timing-function: ease-in-out;
  transition-duration: var(--transition-duration);
}

.header__search__field:focus-visible,
.header__user:focus-visible {
  outline-color: var(--color-grey-darker-bg);
}

.logo__icone,
.logo__text {
  transition: fill var(--transition-duration) ease-in-out;
}

.header__logo:focus-visible {
  outline: 0;
}

.header__logo:focus-visible .logo__icone {
  fill: #ff8962;
}

.header__logo:focus-visible .logo__text {
  fill: gray;
}

.header__user:active {
  opacity: 1;
  background-color: var(--color-grey-darker-bg);
}

.aside__btn:focus {
  outline: none;
  background-color: #fff;
}

.header {
  padding-right: 50px;
}

.header__logo {
  max-width: 289px;
  width: 100%;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header__search {
  padding-left: 50px;
  padding-top: 15px;
  padding-bottom: 15px;
  flex: 1;
  margin-right: 30px;
}

.header__search__field {
  max-width: 1010px;
  border: none;
  width: 100%;
  min-width: 250px;
  padding: 15px 12px 15px 47px;
  border-radius: 30px;
  background-color: var(--color-greybg);
  font-size: 14px;
  letter-spacing: .09em;
  color: var(--color-greytxt);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: left 15px top 10px;
}

.header__search__field::placeholder {
  font-size: 12px;
}

.header__user {
  background-color: var(--color-greybg);
  align-self: center;
  padding: 5px 13px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  max-width: 246px;
  width: 100%;
}

.header__user__img {
  width: 42px;
  height: 42px;
  border-radius: 100%;
  margin-right: 11px;
}

.header__user__text {
  margin-right: auto;
}

.aside {
  padding: 46px 0px;
  background-color: var(--color-greybg);
  max-width: 289px;
  width: 100%;
  overflow: auto;
}

.aside__list {
  font-size: 20px;
}

.aside__btn {
  padding: 15px 30px;
  display: flex;
  align-items: center;
  width: 100%;
}

.aside__btn.aside__btn-active {
  background-color: #fff;
}

.aside__btn svg {
  color: #FC6D3E;

  margin-right: 12px;
}

.main {
  padding: 35px 53px 145px 46px;
  flex: 1;
}

.tabs-content {
  display: none;
}

.title__h2 {
  font-size: 30px;
  font-weight: normal;
}

.tracks__header {
  color: var(--color-greytxt);
  font-size: 12px;
  letter-spacing: .09em;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

.tracks__header__number {
  width: 100%;
  max-width: 40px;
}

.tracks__header__name {
  max-width: 434px;
  width: 100%;
}

.tracks__header__albom {
  max-width: 363px;
  width: 100%;
}

.tracks__header__data {
  width: 100%;
  max-width: 488px;
  margin-right: auto;
}

.tracks__header__time {
  width: 100%;
  max-width: 200px;
}

.tracks__item {
  position: relative;
  padding-top: 14px;
  padding-bottom: 14px;
  align-items: center;
}

.tracks__item__number {
  width: 100%;
  max-width: 40px;
}

.tracks__item__name {
  max-width: 434px;
  padding-right: 10px;
  width: 100%;
  align-items: center;
  display: flex;
}

.tracks__item__albom {
  max-width: 363px;
  width: 100%;
  padding-right: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tracks__item__data {
  width: 100%;
  max-width: 488px;
  padding-right: 10px;
  margin-right: auto;
  color: var(--color-greytxt);
  font-weight: bold;
}

.tracks__item__like {
  margin-right: 18px;
}

.tracks__item__time {
  width: 100%;
  max-width: 157px;
}

.tracks__item__drop {
  width: 100%;
  max-width: 43px;
}

.track__img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  object-position: center;
  margin-right: 10px;
}

.track__name {
  margin-bottom: 10px;
}

.track__name__link:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-top: 1px solid var(--color-grey-darker-bg);
  border-bottom: 1px solid var(--color-grey-darker-bg);
}

.track__author {
  color: var(--color-greytxt);
  font-weight: 500;
  font-size: 12px;
}

.track__like-btn {
  color: var(--color-greytxt);
  position: relative;
  z-index: 2;
}

.track__like-btn.like-btn--active svg {
  color: var(--color-promo);
}

.track__like-btn path {
  fill: var(--color-greytxt);
}

.track__btn-dropdown {
  position: relative;
  z-index: 2;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  border: 1px solid transparent;
  transition: transform var(--transition-duration) ease-in-out;
}

.data__text {
  margin-right: auto;
}

.section.section--active {
  display: block;
}

.tracks__item__drop {
  position: relative;
}

.track__dropdown {
  position: absolute;
  z-index: 100;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.2));
  border: 1px solid var(--color-greytxt);
  background-color: #fff;
  right: 0;
  min-width: max-content;
  display: flex;
  flex-direction: column;
  display: none;
}

.track__dropdown.dropdown--active {
  display: flex;
}

.track__dropdown button {
  padding: 10px 18px;
  transition: background-color var(--transition-duration) ease-in-out,color var(--transition-duration) ease-in-out;
}

.playlist__list {
  display: flex;
  flex-wrap: wrap;
}

.playlist__item {
  width: calc((100% - 90px)/4);
  margin-bottom: 30px;
  position: relative;
}

.playlist__item:not(:nth-child(4n)) {
  margin-right: 30px;
}

.playlist__image-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  width: 100%;
  aspect-ratio : 1 / 1;
  opacity: 0.5;
}

.playlist__small-btn {
  width: 50%;
}

.playlist__h3 {
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 10px;
}

.playlist__h3__link {
  transition-property: color,background-color,opacity;
  transition-duration: var(--transition-duration);
  transition-timing-function: ease-in-out;
}

.playlist__h3__link:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.playlist__h3__link:focus-visible {
  outline: none;
  color: #fff;
  background-color: var(--color-promo);
}

.playlist__h3__link:active {
  opacity: .5;
}

.playlist__img {
  width: 100%;
  margin-bottom: 20px;
}

.playlist__count {
  color: var(--color-greytxt);
  font-weight: bold;
}

.create-playlist__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.create-playlist__label {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.create-playlist__input {
  margin-top: 5px;
}

.player {
  padding: 20px 50px;
  justify-content: space-between;
  gap: 20px;
}

.player__track__like {
  color: var(--color-grey-bg-btn);
}

.player__track__like_active {
  color: var(--color-promo);
}

.player__track__like-svg {
  width: 22px;
  height: 18px;
}

.player__track-name {
  align-items: center;
  max-width: 388px;
  width: 100%;
}

.player__track__h3 {
  margin: 0;
  margin-right: 12px;
}

.player__track__author {
  margin: 0;
  color: var(--color-greytxt);
  font-size: 12px;
}

.player__track__img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin-right: 10px;
}

.player__name__header {
  align-items: center;
  margin-bottom: 10px;
}

.player__shuffle-svg,
.player__repeat-svg {
  width: 18px;
  height: 18px;
}

.player__skipback-svg,
.player__skipnext-svg {
  width: 16px;
  height: 16px;
}

.player__skipnext-svg {
  transform: rotate(180deg);
}

.player__volume-svg {
  width: 12px;
  height: 14px;
}

.player__controls {
  max-width: 902px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.player__svg {
  color: var(--color-grey-bg-btn);
}

.player__svg_active {
  color: var(--color-promo);
}

.player__command-btn {
  color: var(--color-grey-bg-btn);

  /* transition: color ease-in-out var(--transition-duration); */
}

.player__command-btn:active {
  color: var(--color-promo);
}

.player__play-svg {
  width: 40px;
  height: 40px;
}

.player__controls__header {
  align-self: center;
  display: flex;
  align-self: center;
  margin-bottom: 6px;
}

.player__controls__header button:not(:last-child) {
  margin-right: 20px;
}

.player__controls__footer {
  display: flex;
  align-items: center;
}

.player__range-play {
  flex: 1;
  margin-right: 12px;
}

.player__volume {
  align-self: flex-end;
}

.player__time-start {
  margin-right: 12px;
}

.player__volume {
  display: flex;
  align-items: center;
}

.player__volume svg {
  margin-right: 9px;
}

.player__volume-range {
  width: 72px;
  height: 4px;
}

.player__controls .noUi-handle.noUi-handle-lower {
  display: none;
}

.player__controls .noUi-connects,
.player__volume-range .noUi-connects {
  background-color: var(--color-grey-darker-bg);
}

.player__controls .noUi-horizontal,
.player__volume-range .noUi-horizontal {
  height: 4px;
}

.player__controls .noUi-connect,
.player__volume-range .noUi-connect {
  background-color: var(--color-promo);
}

.player__controls .noUi-target,
.player__volume .noUi-target {
  box-shadow: none;
  border: none;
}

.player__volume .noUi-handle.noUi-handle-lower {
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background-color: var(--color-promo);
  box-shadow: none;
  border: 0;
  transform: translate(-50%, calc(50% - 4px));
}

.player__volume .noUi-handle.noUi-handle-lower:before,
.player__volume .noUi-handle.noUi-handle-lower:after {
  display: none;
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  z-index: 105;
  border-top: 1px solid var(--color-greytxt);
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.2));
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}

.modal_hidden {
  display: none;
}

.modal__overlay {
  cursor: pointer;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
}

.modal__content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
  z-index: 5;
  border: 1px solid VAR(--color-grey-bg-btn);
}

.playlists-modal {
  position: relative;
  max-width: 328px;
  max-height: 600px;
  padding: 20px;
  background: #ffffff;
}

.playlists-modal.show {
  display: block;
}

.playlists-modal__title {
  font-size: 20px;
  color: #11253D;
}

.playlists-modal__playlist {
  width: 288px;
  height: 40px;
  margin-top: 20px;
  cursor: pointer;
}

.playlists-modal__playlist_content {
  padding-left: 3px;
  margin-top: 20px;
  margin-bottom: 20px;
  max-height: 360px;
  overflow-y: auto;
  overflow-x: hidden;
}

.playlists-modal__playlist__image {
  width: 40px;
  height: 40px;
  background: VAR(--color-grey-bg-btn);
  float: left;
}

.playlists-modal__playlist__title {
  padding-left: 10px;
  padding-top: 4px;
  width: 228px;
  font-size: 14px;
  color: #11253D;
  display: inline-block;
  transition: color var(--transition-duration) ease-in-out;
}

.playlists-modal__playlist__info {
  padding-left: 10px;
  padding-top: 4px;
  width: 228px;
  font-size: 12px;
  color: VAR(--color-grey-bg-btn);
  display: inline-block;
}

.playlists-modal__playlist:hover .playlists-modal__playlist__title {
  color: var(--color-promo);
}

.playlists-modal__footer {
  width: 114px;
  height: 32px;
  padding: 20px;
}

.playlists-modal__close-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: VAR(--color-grey-bg-btn);
  color: #171717;
  font-size: 14px;
  width: 114px;
  height: 32px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
}

@media (min-width: 1200px) {
  .header__search__field:hover {
    opacity: .6;
  }

  .header__user:hover {
    opacity: .6;
  }

  .header__logo:hover .logo__icone {
    fill: #ff8962;
  }

  .header__logo:hover .logo__text {
    fill: gray;
  }

  .aside__btn:hover {
    background-color: #fff;
  }

  .track__name__link:hover {
    color: var(--color-promo);
  }

  .track__name__link:hover::before {
    border-color: var(--color-promo);
  }

  .track__btn-dropdown:hover circle {
    fill: var(--color-promo);
  }

  .track__btn-dropdown:hover {
    border-color: var(--color-grey-bg-btn);
  }

  .track__dropdown button:hover {
    background-color: var(--color-promo);
    color: #fff;
  }

  .playlist__h3__link:hover:not(:focus-visible) {
    color: var(--color-promo);
  }
}

@media (max-width: 1440px) {
  .tracks__header__albom {
    max-width: 262px;
  }

  .tracks__header__data {
    max-width: 239px;
  }

  .tracks__header__time {
    max-width: 99px;
  }

  .tracks__item__albom {
    max-width: 262px;
  }

  .tracks__item__data {
    max-width: 239px;
  }

  .tracks__item__time {
    max-width: 56px;
  }

  .playlist__h3 {
    font-size: 24px;
  }

  .playlist__item {
    width: calc((100% - 90px)/4);
  }

  .playlist__item:not(:nth-child(3n)) {
    margin-right: 0;
  }

  .playlist__item:not(:nth-child(4n)) {
    margin-right: 30px;
  }
}

@media (max-width: 1300px) {
  .content-wrap {
    flex-direction: column;
  }

  .header__logo {
    padding-left: 46px;
    padding-right: 46px;
    justify-content: flex-start;
  }

  .aside {
    max-width: 100%;
    padding: 20px 46px;
  }

  .aside__item:last-child {
    margin-bottom: 0;
  }

  .aside__nav {
    display: flex;
    flex-direction: row;
  }

  .aside__list {
    display: flex;
    align-items: center;
  }

  .aside__item {
    margin-right: 10px;
    max-width: max-content;
  }

  .aside__btn {
    min-width: max-content;
    display: inline-flex;
    border-radius: 30px;
    background-color: #fff;
  }

  .aside__btn.aside__btn-active {
    background-color: var(--color-promo);
    color: #fff;
  }

  .aside__btn.aside__btn-active svg {
    color: white;
  }

  .aside__btn.aside__btn-active path {
    stroke: #fff;
  }
}

@media (max-width: 992px) {
  .aside__search-container {
    display: block;
    margin-right: 10px;
  }

  .aside__search {
    height: 57px;
  }

  .sidebar-loading {
    padding-left: 25px;
    padding-right: 25px;
  }

  .playlist__item {
    width: calc((100% - 60px)/3);
  }

  .playlist__item:not(:nth-child(4n)) {
    margin-right: 0px;
  }

  .playlist__item:not(:nth-child(3n)) {
    margin-right: 30px;
  }

  .header__user {
    margin-left: auto;
  }

  .aside__nav {
    display: flex;
    align-items: center;
  }

  .header__search {
    position: absolute;
    width: 100%;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 0;
    padding-bottom: 0;
    top: 0;
    transform: translateX(-102%);
    transition: transform .3s ease-in-out;
  }

  .header__search.search--active {
    transform: translateX(0%);
  }

  .header__search__field {
    background-color: #fff;
    box-shadow: 2px 5px 35px -18px;
    height: 60px;
    background-position: left 2% center;
  }

  .search__btn-open {
    display: flex;
    background-color: #fff;
    min-width: 44px;
    width: 100%;
    border-radius: 100%;
    height: 44px;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
  }

  .tracks__header,
  .data__text,
  .tracks__item__time,
  .player__volume {
    display: none;
  }

  .tracks__item__albom,
  .tracks__item__data {
    flex: 4;
    max-width: none;
  }

  .tracks__item__name {
    max-width: none;
    flex: 8;
  }
}

@media (max-width: 768px) {
  .playlist__item {
    width: calc((100% - 30px)/2);
  }

  .playlist__item:not(:nth-child(3n)) {
    margin-right: 0px;
  }

  .playlist__item:not(:nth-child(2n)) {
    margin-right: 30px;
  }

  .tracks__item:last-child {
    margin-bottom: 60px;
  }

  .tracks__item__albom {
    display: none;
  }

  .tracks__item__data {
    flex: 0;
  }

  .player {
    flex-direction: column;
  }
}

@media (max-width: 576px) {
  .aside__search {
    font-size: 14px;
  }

  .playlist__item {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    background-color: #fff;
  }

  .playlist__item:not(:nth-child(2n)) {
    margin-right: 0px;
  }

  .aside__btn {
    font-size: 14px;
  }

  .aside__btn svg {
    width: 17px;
  }

  .playlist__img {
    margin-bottom: 0;
    margin-right: 20px;
    height: 100%;
    width: 99px;
  }

  .playlist__image-container {
    margin-bottom: 0;
    width: 100px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-right: 18px;
  }

  .playlist__button-img {
    width: 60px;
    height: 60px;
  }

  .playlist__content {
    flex: 1;
  }

  .playlist__h3 {
    font-size: 18px;
  }

  .playlist__count {
    font-size: 12px;
  }

  .track__name {
    margin-bottom: 4px;
  }

  .track__content {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .header__logo {
    padding: 0;
    margin-right: auto;
  }

  .track__name__link {
    font-size: 18px;
  }

  .header__search {
    padding-left: 16px;
    padding-right: 16px;
  }

  .header__logo svg {
    width: 115px;
  }

  .header {
    padding: 17px 16px;
  }

  .header__user {
    font-size: 12px;
    background-color: transparent;
    padding: 0;
    max-width: max-content;
  }

  .header__user__text {
    margin: 0;
  }

  .player__controls__header {
    gap: 35px;
    padding-top: 10px;
    margin-bottom: 20px;
  }

  .player {
    position: relative;
  }

  .player__controls__header svg {
    width: 20px;
    height: 20px;
  }

  .player__play-btn {
    position: absolute;
    top: 14px;
    right: 16px;
  }

  .player__play-btn svg {
    width: 40px;
    height: 40px;
  }

  .player__controls__header button:not(:last-child) {
    margin: 0;
  }

  .player__track-name {
    max-width: 100%;
    padding-right: 50px;
  }

  .player {
    padding: 14px 16px;
  }

  .main {
    padding: 0px 16px 145px 16px;
    background-color: var(--color-greybg);
  }

  .tracks__item {
    background-color: #fff;
    padding-top: 0;
    padding-bottom: 0;
  }

  .tracks__item:last-child {
    margin-bottom: 50px;
  }

  .tracks__item:not(:last-child) {
    margin-bottom: 20px;
  }

  .player__track__h3 {
    font-size: 14px;
  }

  .track__name__link:before {
    border: none;
  }

  .header__search {
    left: 0;
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .aside {
    padding: 20px 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/resources/css/style.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,2BAA2B;EAC3B,0CAA0C;EAC1C,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE,uEAAuE;AACzE;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,6BAA6B;EAC7B,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mHAAgH;AAClH;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mHAAgH;AAClH;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mHAAoH;AACtH;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;;EAEE,+DAA+D;AACjE;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;;EAEE,kDAAkD;EAClD,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,yDAA0C;EAC1C,4BAA4B;EAC5B,qCAAqC;EACrC,8BAA8B;EAC9B,2DAA2D;EAC3D,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,8BAA8B;EAC9B,2DAA2D;EAC3D,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,uDAAuD;AACzD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,yDAA0C;EAC1C,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;;EAEd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,OAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iDAAiD;EACjD,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mDAAmD;EACnD,sCAAsC;EACtC,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gHAAgH;AAClH;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;;EAE/B,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,SAAS;EACT,2CAA2C;AAC7C;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,0CAA0C;EAC1C,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,MAAM;IACN,4BAA4B;IAC5B,qCAAqC;EACvC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;;IAEE,OAAO;IACP,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,OAAO;EACT;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,6BAA6B;IAC7B,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,OAAO;IACP,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\nhtml {\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n}\n\nmain {\n  display: block;\n}\n\nh1 {\n  font-size: 2em;\n  margin: .67em 0;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\npre {\n  font-family: monospace,monospace;\n  font-size: 1em;\n}\n\na {\n  background-color: transparent;\n}\n\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  text-decoration: underline dotted;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\ncode,\nkbd,\nsamp {\n  font-family: monospace,monospace;\n  font-size: 1em;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\nimg {\n  border-style: none;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\n\nbutton::-moz-focus-inner,\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\nbutton:-moz-focusring,\n[type=button]:-moz-focusring,\n[type=reset]:-moz-focusring,\n[type=submit]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\nfieldset {\n  padding: .35em .75em .625em;\n}\n\nlegend {\n  box-sizing: border-box;\n  color: inherit;\n  display: table;\n  max-width: 100%;\n  padding: 0;\n  white-space: normal;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\ntextarea {\n  overflow: auto;\n}\n\n[type=checkbox],\n[type=radio] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  font: inherit;\n}\n\ndetails {\n  display: block;\n}\n\nsummary {\n  display: list-item;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none;\n}\n\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.noUi-target {\n  position: relative;\n}\n\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n\n.noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {\n  left: 0;\n  right: auto;\n}\n\n.noUi-vertical .noUi-origin {\n  top: -100%;\n  width: 0;\n}\n\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform .3s;\n  transition: transform .3s;\n}\n\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n\n.noUi-horizontal {\n  height: 18px;\n}\n\n.noUi-horizontal .noUi-handle {\n  width: 34px;\n  height: 28px;\n  right: -17px;\n  top: -6px;\n}\n\n.noUi-vertical {\n  width: 18px;\n}\n\n.noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 34px;\n  right: -6px;\n  bottom: -17px;\n}\n\n.noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {\n  left: -17px;\n  right: auto;\n}\n\n.noUi-target {\n  background: #fafafa;\n  border-radius: 4px;\n  border: 1px solid #d3d3d3;\n  box-shadow: inset 0 1px 1px #f0f0f0,0 3px 6px -5px #bbb;\n}\n\n.noUi-connects {\n  border-radius: 3px;\n}\n\n.noUi-connect {\n  background: #3fb8af;\n}\n\n.noUi-draggable {\n  cursor: ew-resize;\n}\n\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n\n.noUi-handle {\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  background: #fff;\n  cursor: default;\n  box-shadow: inset 0 0 1px #fff,inset 0 1px 7px #ebebeb,0 3px 6px -3px #bbb;\n}\n\n.noUi-active {\n  box-shadow: inset 0 0 1px #fff,inset 0 1px 7px #ddd,0 3px 6px -3px #bbb;\n}\n\n.noUi-handle:before,\n.noUi-handle:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  height: 14px;\n  width: 1px;\n  background: #e8e7e6;\n  left: 14px;\n  top: 6px;\n}\n\n.noUi-handle:after {\n  left: 17px;\n}\n\n.noUi-vertical .noUi-handle:before,\n.noUi-vertical .noUi-handle:after {\n  width: 14px;\n  height: 1px;\n  left: 6px;\n  top: 14px;\n}\n\n.noUi-vertical .noUi-handle:after {\n  top: 17px;\n}\n\n[disabled] .noUi-connect {\n  background: #b8b8b8;\n}\n\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n\n.noUi-marker {\n  position: absolute;\n  background: #ccc;\n}\n\n.noUi-marker-sub {\n  BACKGROUND: var(--color-grey-bg-btn);\n}\n\n.noUi-marker-large {\n  BACKGROUND: var(--color-grey-bg-btn);\n}\n\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n\n.noUi-horizontal .noUi-origin>.noUi-tooltip {\n  -webkit-transform: translate(50%, 0);\n  transform: translate(50%, 0);\n  left: auto;\n  bottom: 10px;\n}\n\n.noUi-vertical .noUi-origin>.noUi-tooltip {\n  -webkit-transform: translate(0, -18px);\n  transform: translate(0, -18px);\n  top: auto;\n  right: 28px;\n}\n\nbutton,\ninput,\ntextarea {\n  font-family: inherit;\n}\n\nhtml {\n  box-sizing: border-box;\n}\n\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nul {\n  margin-top: 0;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nul {\n  margin: 0;\n}\n\nbutton {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\nbody {\n  font-family: \"Circular\",sans-serif;\n  color: var(--color-blacktxt);\n}\n\n:root {\n  --color-blacktxt: #11253D;\n  --color-greytxt: #A4A4A4;\n  --color-lightgreytxt: #C4C4C4;\n  --color-greybg: #F5F5F5;\n  --color-grey-darker-bg: #E8E8E8;\n  --color-grey-bg-btn: #AAAAAA;\n  --color-promo: #FC6D3E;\n  --transition-duration: .3s;\n}\n\n.visually-hidden {\n  position: absolute !important;\n  clip: rect(1px 1px 1px 1px);\n  clip: rect(1px, 1px, 1px, 1px);\n  padding: 0 !important;\n  border: 0 !important;\n  height: 1px !important;\n  width: 1px !important;\n  overflow: hidden;\n}\n\n.flex {\n  display: flex;\n}\n\n.content-wrap {\n  flex: 1;\n}\n\n.search__btn-open {\n  display: none;\n}\n\n.noUi-target,\n.player__volume .noUi-handle.noUi-handle-lower {\n  cursor: pointer;\n}\n\n@font-face {\n  font-family: \"Circular\";\n  font-style: normal;\n  font-weight: bold;\n  src: url(\"../fonts/CircularStd-Bold.woff2\") format(\"woff2\"),url(\"../fonts/CircularStd-Bold.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Circular\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"../fonts/CircularStd-Book.woff2\") format(\"woff2\"),url(\"../fonts/CircularStd-Book.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Circular\";\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"../fonts/CircularStd-Medium.woff2\") format(\"woff2\"),url(\"../fonts/CircularStd-Medium.woff\") format(\"woff\");\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  min-height: 50vh;\n}\n\n.loading_small {\n  min-height: 0;\n}\n\n.loading_hidden {\n  display: none;\n}\n\n@keyframes rotate{\n  to { \n    transform: rotate(360deg); \n  }\n}\n\n.loading__spinner {\n  opacity: 0.7;\n  width: 40%;\n  animation: rotate 800ms linear infinite; \n}\n\n.profile-loading {\n  height: 35px;\n}\n\n.profile-loading .loading__spinner {\n  width: 30px;\n}\n\n.sidebar-loading {\n  height: 110px;\n}\n\n.sidebar-loading .loading__spinner {\n  width: 40px;\n}\n\n.tracks-loading .loading__spinner {\n  width: 10%;\n  min-width: 40px;\n}\n\n.modal-loading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.modal-loading .loading__spinner {\n  width: 20%;\n}\n\n.player-loading .loading__spinner {\n  width: 40px;\n}\n\n.common-input {\n    font-weight: 400;\n    height: 30px;\n}\n\n.common-input:focus-visible {\n  outline: 1px solid #FC6D3E;\n}\n\n.common-btn {\n  bottom: 20px;\n  right: 20px;\n  background: #FC6D3E;\n  color: #171717;\n  font-size: 14px;\n  width: 114px;\n  height: 32px;\n  padding: 10px;\n  color: white;\n  text-align: center;\n  cursor: pointer;\n}\n\n.track__btn-dropdown:focus {\n  outline: none;\n  border-color: var(--color-grey-bg-btn);\n}\n\n.track__btn-dropdown:focus circle {\n  fill: var(--color-promo);\n}\n\n.track__btn-dropdown.btn-dropdown--active\n{\n  transform: rotate(90deg);\n}\n\n.track__btn-dropdown svg {\n  transition: transform var(--transition-duration) ease-in-out;\n}\n\n.track__name__link::before,\n.track__btn-dropdown {\n  transition: border-color var(--transition-duration) ease-in-out;\n}\n\n.track__name__link {\n  transition: color var(--transition-duration) ease-in-out;\n}\n\n.track__like-btn svg,\n.track__btn-dropdown circle {\n  transition: var(--transition-duration) ease-in-out;\n  transition-property: fill, color; \n}\n\n.track__like-icon {\n  width: 20px;\n  height: 18px;\n}\n\n.track__name__link:focus {\n  color: var(--color-promo);\n}\n\n.track__name__link:focus::before {\n  border-color: var(--color-promo);\n}\n\n.track__like-btn:focus-visible svg {\n  color: var(--color-promo);\n}\n\n.track__name__link:focus-visible,\n.track__like-btn:focus-visible {\n  outline: none;\n}\n\n.aside__item:last-child {\n  margin-bottom: 70px;\n}\n\n.aside__search-container {\n  display: none;\n}\n\n.aside__search {\n  max-width: 1010px;\n  border: none;\n  width: 100%;\n  min-width: 250px;\n  padding: 15px 12px 15px 47px;\n  border-radius: 30px;\n  background-color: white;\n  color: var(--color-greytxt);\n  background-image: url(\"../img/search.svg\");\n  background-repeat: no-repeat;\n  background-position: left 15px center;\n  outline: 2px solid transparent;\n  transition-property: outline-color,opacity,background-color;\n  transition-timing-function: ease-in-out;\n  transition-duration: var(--transition-duration);\n}\n\n.aside__btn {\n  transition-property: background-color;\n  transition-timing-function: ease-in-out;\n  transition-duration: var(--transition-duration);\n}\n\n.aside__btn-note-icon {\n  width: 25px;\n  height: 27px;\n}\n\n.aside__btn-play-icon {\n  width: 22px;\n  height: 26px;\n}\n\n.header__search__field,\n.header__user {\n  outline: 2px solid transparent;\n  transition-property: outline-color,opacity,background-color;\n  transition-timing-function: ease-in-out;\n  transition-duration: var(--transition-duration);\n}\n\n.header__search__field:focus-visible,\n.header__user:focus-visible {\n  outline-color: var(--color-grey-darker-bg);\n}\n\n.logo__icone,\n.logo__text {\n  transition: fill var(--transition-duration) ease-in-out;\n}\n\n.header__logo:focus-visible {\n  outline: 0;\n}\n\n.header__logo:focus-visible .logo__icone {\n  fill: #ff8962;\n}\n\n.header__logo:focus-visible .logo__text {\n  fill: gray;\n}\n\n.header__user:active {\n  opacity: 1;\n  background-color: var(--color-grey-darker-bg);\n}\n\n.aside__btn:focus {\n  outline: none;\n  background-color: #fff;\n}\n\n.header {\n  padding-right: 50px;\n}\n\n.header__logo {\n  max-width: 289px;\n  width: 100%;\n  padding: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.header__search {\n  padding-left: 50px;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  flex: 1;\n  margin-right: 30px;\n}\n\n.header__search__field {\n  max-width: 1010px;\n  border: none;\n  width: 100%;\n  min-width: 250px;\n  padding: 15px 12px 15px 47px;\n  border-radius: 30px;\n  background-color: var(--color-greybg);\n  font-size: 14px;\n  letter-spacing: .09em;\n  color: var(--color-greytxt);\n  background-image: url(\"../img/search.svg\");\n  background-repeat: no-repeat;\n  background-position: left 15px top 10px;\n}\n\n.header__search__field::placeholder {\n  font-size: 12px;\n}\n\n.header__user {\n  background-color: var(--color-greybg);\n  align-self: center;\n  padding: 5px 13px;\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  max-width: 246px;\n  width: 100%;\n}\n\n.header__user__img {\n  width: 42px;\n  height: 42px;\n  border-radius: 100%;\n  margin-right: 11px;\n}\n\n.header__user__text {\n  margin-right: auto;\n}\n\n.aside {\n  padding: 46px 0px;\n  background-color: var(--color-greybg);\n  max-width: 289px;\n  width: 100%;\n  overflow: auto;\n}\n\n.aside__list {\n  font-size: 20px;\n}\n\n.aside__btn {\n  padding: 15px 30px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.aside__btn.aside__btn-active {\n  background-color: #fff;\n}\n\n.aside__btn svg {\n  color: #FC6D3E;\n\n  margin-right: 12px;\n}\n\n.main {\n  padding: 35px 53px 145px 46px;\n  flex: 1;\n}\n\n.tabs-content {\n  display: none;\n}\n\n.title__h2 {\n  font-size: 30px;\n  font-weight: normal;\n}\n\n.tracks__header {\n  color: var(--color-greytxt);\n  font-size: 12px;\n  letter-spacing: .09em;\n  align-items: center;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.tracks__header__number {\n  width: 100%;\n  max-width: 40px;\n}\n\n.tracks__header__name {\n  max-width: 434px;\n  width: 100%;\n}\n\n.tracks__header__albom {\n  max-width: 363px;\n  width: 100%;\n}\n\n.tracks__header__data {\n  width: 100%;\n  max-width: 488px;\n  margin-right: auto;\n}\n\n.tracks__header__time {\n  width: 100%;\n  max-width: 200px;\n}\n\n.tracks__item {\n  position: relative;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  align-items: center;\n}\n\n.tracks__item__number {\n  width: 100%;\n  max-width: 40px;\n}\n\n.tracks__item__name {\n  max-width: 434px;\n  padding-right: 10px;\n  width: 100%;\n  align-items: center;\n  display: flex;\n}\n\n.tracks__item__albom {\n  max-width: 363px;\n  width: 100%;\n  padding-right: 22px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tracks__item__data {\n  width: 100%;\n  max-width: 488px;\n  padding-right: 10px;\n  margin-right: auto;\n  color: var(--color-greytxt);\n  font-weight: bold;\n}\n\n.tracks__item__like {\n  margin-right: 18px;\n}\n\n.tracks__item__time {\n  width: 100%;\n  max-width: 157px;\n}\n\n.tracks__item__drop {\n  width: 100%;\n  max-width: 43px;\n}\n\n.track__img {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  object-position: center;\n  margin-right: 10px;\n}\n\n.track__name {\n  margin-bottom: 10px;\n}\n\n.track__name__link:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-top: 1px solid var(--color-grey-darker-bg);\n  border-bottom: 1px solid var(--color-grey-darker-bg);\n}\n\n.track__author {\n  color: var(--color-greytxt);\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.track__like-btn {\n  color: var(--color-greytxt);\n  position: relative;\n  z-index: 2;\n}\n\n.track__like-btn.like-btn--active svg {\n  color: var(--color-promo);\n}\n\n.track__like-btn path {\n  fill: var(--color-greytxt);\n}\n\n.track__btn-dropdown {\n  position: relative;\n  z-index: 2;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n  border: 1px solid transparent;\n  transition: transform var(--transition-duration) ease-in-out;\n}\n\n.data__text {\n  margin-right: auto;\n}\n\n.section.section--active {\n  display: block;\n}\n\n.tracks__item__drop {\n  position: relative;\n}\n\n.track__dropdown {\n  position: absolute;\n  z-index: 100;\n  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.2));\n  border: 1px solid var(--color-greytxt);\n  background-color: #fff;\n  right: 0;\n  min-width: max-content;\n  display: flex;\n  flex-direction: column;\n  display: none;\n}\n\n.track__dropdown.dropdown--active {\n  display: flex;\n}\n\n.track__dropdown button {\n  padding: 10px 18px;\n  transition: background-color var(--transition-duration) ease-in-out,color var(--transition-duration) ease-in-out;\n}\n\n.playlist__list {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.playlist__item {\n  width: calc((100% - 90px)/4);\n  margin-bottom: 30px;\n  position: relative;\n}\n\n.playlist__item:not(:nth-child(4n)) {\n  margin-right: 30px;\n}\n\n.playlist__image-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 30px;\n  width: 100%;\n  aspect-ratio : 1 / 1;\n  opacity: 0.5;\n}\n\n.playlist__small-btn {\n  width: 50%;\n}\n\n.playlist__h3 {\n  font-size: 30px;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.playlist__h3__link {\n  transition-property: color,background-color,opacity;\n  transition-duration: var(--transition-duration);\n  transition-timing-function: ease-in-out;\n}\n\n.playlist__h3__link:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.playlist__h3__link:focus-visible {\n  outline: none;\n  color: #fff;\n  background-color: var(--color-promo);\n}\n\n.playlist__h3__link:active {\n  opacity: .5;\n}\n\n.playlist__img {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.playlist__count {\n  color: var(--color-greytxt);\n  font-weight: bold;\n}\n\n.create-playlist__content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.create-playlist__label {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n\n.create-playlist__input {\n  margin-top: 5px;\n}\n\n.player {\n  padding: 20px 50px;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.player__track__like {\n  color: var(--color-grey-bg-btn);\n}\n\n.player__track__like_active {\n  color: var(--color-promo);\n}\n\n.player__track__like-svg {\n  width: 22px;\n  height: 18px;\n}\n\n.player__track-name {\n  align-items: center;\n  max-width: 388px;\n  width: 100%;\n}\n\n.player__track__h3 {\n  margin: 0;\n  margin-right: 12px;\n}\n\n.player__track__author {\n  margin: 0;\n  color: var(--color-greytxt);\n  font-size: 12px;\n}\n\n.player__track__img {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  margin-right: 10px;\n}\n\n.player__name__header {\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.player__shuffle-svg,\n.player__repeat-svg {\n  width: 18px;\n  height: 18px;\n}\n\n.player__skipback-svg,\n.player__skipnext-svg {\n  width: 16px;\n  height: 16px;\n}\n\n.player__skipnext-svg {\n  transform: rotate(180deg);\n}\n\n.player__volume-svg {\n  width: 12px;\n  height: 14px;\n}\n\n.player__controls {\n  max-width: 902px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.player__svg {\n  color: var(--color-grey-bg-btn);\n}\n\n.player__svg_active {\n  color: var(--color-promo);\n}\n\n.player__command-btn {\n  color: var(--color-grey-bg-btn);\n\n  /* transition: color ease-in-out var(--transition-duration); */\n}\n\n.player__command-btn:active {\n  color: var(--color-promo);\n}\n\n.player__play-svg {\n  width: 40px;\n  height: 40px;\n}\n\n.player__controls__header {\n  align-self: center;\n  display: flex;\n  align-self: center;\n  margin-bottom: 6px;\n}\n\n.player__controls__header button:not(:last-child) {\n  margin-right: 20px;\n}\n\n.player__controls__footer {\n  display: flex;\n  align-items: center;\n}\n\n.player__range-play {\n  flex: 1;\n  margin-right: 12px;\n}\n\n.player__volume {\n  align-self: flex-end;\n}\n\n.player__time-start {\n  margin-right: 12px;\n}\n\n.player__volume {\n  display: flex;\n  align-items: center;\n}\n\n.player__volume svg {\n  margin-right: 9px;\n}\n\n.player__volume-range {\n  width: 72px;\n  height: 4px;\n}\n\n.player__controls .noUi-handle.noUi-handle-lower {\n  display: none;\n}\n\n.player__controls .noUi-connects,\n.player__volume-range .noUi-connects {\n  background-color: var(--color-grey-darker-bg);\n}\n\n.player__controls .noUi-horizontal,\n.player__volume-range .noUi-horizontal {\n  height: 4px;\n}\n\n.player__controls .noUi-connect,\n.player__volume-range .noUi-connect {\n  background-color: var(--color-promo);\n}\n\n.player__controls .noUi-target,\n.player__volume .noUi-target {\n  box-shadow: none;\n  border: none;\n}\n\n.player__volume .noUi-handle.noUi-handle-lower {\n  width: 12px;\n  height: 12px;\n  border-radius: 100%;\n  background-color: var(--color-promo);\n  box-shadow: none;\n  border: 0;\n  transform: translate(-50%, calc(50% - 4px));\n}\n\n.player__volume .noUi-handle.noUi-handle-lower:before,\n.player__volume .noUi-handle.noUi-handle-lower:after {\n  display: none;\n}\n\n.footer {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  background-color: #fff;\n  z-index: 105;\n  border-top: 1px solid var(--color-greytxt);\n  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.2));\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 100;\n}\n\n.modal_hidden {\n  display: none;\n}\n\n.modal__overlay {\n  cursor: pointer;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.modal__content {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -60%);\n  z-index: 5;\n  border: 1px solid VAR(--color-grey-bg-btn);\n}\n\n.playlists-modal {\n  position: relative;\n  max-width: 328px;\n  max-height: 600px;\n  padding: 20px;\n  background: #ffffff;\n}\n\n.playlists-modal.show {\n  display: block;\n}\n\n.playlists-modal__title {\n  font-size: 20px;\n  color: #11253D;\n}\n\n.playlists-modal__playlist {\n  width: 288px;\n  height: 40px;\n  margin-top: 20px;\n  cursor: pointer;\n}\n\n.playlists-modal__playlist_content {\n  padding-left: 3px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  max-height: 360px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.playlists-modal__playlist__image {\n  width: 40px;\n  height: 40px;\n  background: VAR(--color-grey-bg-btn);\n  float: left;\n}\n\n.playlists-modal__playlist__title {\n  padding-left: 10px;\n  padding-top: 4px;\n  width: 228px;\n  font-size: 14px;\n  color: #11253D;\n  display: inline-block;\n  transition: color var(--transition-duration) ease-in-out;\n}\n\n.playlists-modal__playlist__info {\n  padding-left: 10px;\n  padding-top: 4px;\n  width: 228px;\n  font-size: 12px;\n  color: VAR(--color-grey-bg-btn);\n  display: inline-block;\n}\n\n.playlists-modal__playlist:hover .playlists-modal__playlist__title {\n  color: var(--color-promo);\n}\n\n.playlists-modal__footer {\n  width: 114px;\n  height: 32px;\n  padding: 20px;\n}\n\n.playlists-modal__close-btn {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  background: VAR(--color-grey-bg-btn);\n  color: #171717;\n  font-size: 14px;\n  width: 114px;\n  height: 32px;\n  padding: 10px;\n  text-align: center;\n  cursor: pointer;\n}\n\n@media (min-width: 1200px) {\n  .header__search__field:hover {\n    opacity: .6;\n  }\n\n  .header__user:hover {\n    opacity: .6;\n  }\n\n  .header__logo:hover .logo__icone {\n    fill: #ff8962;\n  }\n\n  .header__logo:hover .logo__text {\n    fill: gray;\n  }\n\n  .aside__btn:hover {\n    background-color: #fff;\n  }\n\n  .track__name__link:hover {\n    color: var(--color-promo);\n  }\n\n  .track__name__link:hover::before {\n    border-color: var(--color-promo);\n  }\n\n  .track__btn-dropdown:hover circle {\n    fill: var(--color-promo);\n  }\n\n  .track__btn-dropdown:hover {\n    border-color: var(--color-grey-bg-btn);\n  }\n\n  .track__dropdown button:hover {\n    background-color: var(--color-promo);\n    color: #fff;\n  }\n\n  .playlist__h3__link:hover:not(:focus-visible) {\n    color: var(--color-promo);\n  }\n}\n\n@media (max-width: 1440px) {\n  .tracks__header__albom {\n    max-width: 262px;\n  }\n\n  .tracks__header__data {\n    max-width: 239px;\n  }\n\n  .tracks__header__time {\n    max-width: 99px;\n  }\n\n  .tracks__item__albom {\n    max-width: 262px;\n  }\n\n  .tracks__item__data {\n    max-width: 239px;\n  }\n\n  .tracks__item__time {\n    max-width: 56px;\n  }\n\n  .playlist__h3 {\n    font-size: 24px;\n  }\n\n  .playlist__item {\n    width: calc((100% - 90px)/4);\n  }\n\n  .playlist__item:not(:nth-child(3n)) {\n    margin-right: 0;\n  }\n\n  .playlist__item:not(:nth-child(4n)) {\n    margin-right: 30px;\n  }\n}\n\n@media (max-width: 1300px) {\n  .content-wrap {\n    flex-direction: column;\n  }\n\n  .header__logo {\n    padding-left: 46px;\n    padding-right: 46px;\n    justify-content: flex-start;\n  }\n\n  .aside {\n    max-width: 100%;\n    padding: 20px 46px;\n  }\n\n  .aside__item:last-child {\n    margin-bottom: 0;\n  }\n\n  .aside__nav {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .aside__list {\n    display: flex;\n    align-items: center;\n  }\n\n  .aside__item {\n    margin-right: 10px;\n    max-width: max-content;\n  }\n\n  .aside__btn {\n    min-width: max-content;\n    display: inline-flex;\n    border-radius: 30px;\n    background-color: #fff;\n  }\n\n  .aside__btn.aside__btn-active {\n    background-color: var(--color-promo);\n    color: #fff;\n  }\n\n  .aside__btn.aside__btn-active svg {\n    color: white;\n  }\n\n  .aside__btn.aside__btn-active path {\n    stroke: #fff;\n  }\n}\n\n@media (max-width: 992px) {\n  .aside__search-container {\n    display: block;\n    margin-right: 10px;\n  }\n\n  .aside__search {\n    height: 57px;\n  }\n\n  .sidebar-loading {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n\n  .playlist__item {\n    width: calc((100% - 60px)/3);\n  }\n\n  .playlist__item:not(:nth-child(4n)) {\n    margin-right: 0px;\n  }\n\n  .playlist__item:not(:nth-child(3n)) {\n    margin-right: 30px;\n  }\n\n  .header__user {\n    margin-left: auto;\n  }\n\n  .aside__nav {\n    display: flex;\n    align-items: center;\n  }\n\n  .header__search {\n    position: absolute;\n    width: 100%;\n    padding-left: 50px;\n    padding-right: 50px;\n    padding-top: 0;\n    padding-bottom: 0;\n    top: 0;\n    transform: translateX(-102%);\n    transition: transform .3s ease-in-out;\n  }\n\n  .header__search.search--active {\n    transform: translateX(0%);\n  }\n\n  .header__search__field {\n    background-color: #fff;\n    box-shadow: 2px 5px 35px -18px;\n    height: 60px;\n    background-position: left 2% center;\n  }\n\n  .search__btn-open {\n    display: flex;\n    background-color: #fff;\n    min-width: 44px;\n    width: 100%;\n    border-radius: 100%;\n    height: 44px;\n    justify-content: center;\n    align-items: center;\n    margin-right: 20px;\n  }\n\n  .tracks__header,\n  .data__text,\n  .tracks__item__time,\n  .player__volume {\n    display: none;\n  }\n\n  .tracks__item__albom,\n  .tracks__item__data {\n    flex: 4;\n    max-width: none;\n  }\n\n  .tracks__item__name {\n    max-width: none;\n    flex: 8;\n  }\n}\n\n@media (max-width: 768px) {\n  .playlist__item {\n    width: calc((100% - 30px)/2);\n  }\n\n  .playlist__item:not(:nth-child(3n)) {\n    margin-right: 0px;\n  }\n\n  .playlist__item:not(:nth-child(2n)) {\n    margin-right: 30px;\n  }\n\n  .tracks__item:last-child {\n    margin-bottom: 60px;\n  }\n\n  .tracks__item__albom {\n    display: none;\n  }\n\n  .tracks__item__data {\n    flex: 0;\n  }\n\n  .player {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 576px) {\n  .aside__search {\n    font-size: 14px;\n  }\n\n  .playlist__item {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    background-color: #fff;\n  }\n\n  .playlist__item:not(:nth-child(2n)) {\n    margin-right: 0px;\n  }\n\n  .aside__btn {\n    font-size: 14px;\n  }\n\n  .aside__btn svg {\n    width: 17px;\n  }\n\n  .playlist__img {\n    margin-bottom: 0;\n    margin-right: 20px;\n    height: 100%;\n    width: 99px;\n  }\n\n  .playlist__image-container {\n    margin-bottom: 0;\n    width: 100px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    margin-right: 18px;\n  }\n\n  .playlist__button-img {\n    width: 60px;\n    height: 60px;\n  }\n\n  .playlist__content {\n    flex: 1;\n  }\n\n  .playlist__h3 {\n    font-size: 18px;\n  }\n\n  .playlist__count {\n    font-size: 12px;\n  }\n\n  .track__name {\n    margin-bottom: 4px;\n  }\n\n  .track__content {\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n\n  .header__logo {\n    padding: 0;\n    margin-right: auto;\n  }\n\n  .track__name__link {\n    font-size: 18px;\n  }\n\n  .header__search {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .header__logo svg {\n    width: 115px;\n  }\n\n  .header {\n    padding: 17px 16px;\n  }\n\n  .header__user {\n    font-size: 12px;\n    background-color: transparent;\n    padding: 0;\n    max-width: max-content;\n  }\n\n  .header__user__text {\n    margin: 0;\n  }\n\n  .player__controls__header {\n    gap: 35px;\n    padding-top: 10px;\n    margin-bottom: 20px;\n  }\n\n  .player {\n    position: relative;\n  }\n\n  .player__controls__header svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  .player__play-btn {\n    position: absolute;\n    top: 14px;\n    right: 16px;\n  }\n\n  .player__play-btn svg {\n    width: 40px;\n    height: 40px;\n  }\n\n  .player__controls__header button:not(:last-child) {\n    margin: 0;\n  }\n\n  .player__track-name {\n    max-width: 100%;\n    padding-right: 50px;\n  }\n\n  .player {\n    padding: 14px 16px;\n  }\n\n  .main {\n    padding: 0px 16px 145px 16px;\n    background-color: var(--color-greybg);\n  }\n\n  .tracks__item {\n    background-color: #fff;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .tracks__item:last-child {\n    margin-bottom: 50px;\n  }\n\n  .tracks__item:not(:last-child) {\n    margin-bottom: 20px;\n  }\n\n  .player__track__h3 {\n    font-size: 14px;\n  }\n\n  .track__name__link:before {\n    border: none;\n  }\n\n  .header__search {\n    left: 0;\n    width: 100%;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .aside {\n    padding: 20px 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
